import React, { useState, useEffect } from 'react';
import { Divider, Rate, Typography, List, Modal, Row, Col, Card, Image } from 'antd';
import { sellerMarketplaces } from '../../../utils/const';

const { Text, Title } = Typography;
export const AttributesModal = ({ visible, setVisible }) => {

    const [attributes, setAttributes] = useState(null);
    const [images, setImages] = useState([]);

    const getAttributesByMarketplace = {
        "Amazon": (attribute, key) => {
            if (attribute?.length > 0) {
                if (attribute[0]?.value) {
                    return { name: key, value: attribute?.map(att => att?.value?.trim())?.join(".") }
                }
            }
            if (attribute?.value) {
                return { name: key, value: Array.isArray(attribute.value) ? attribute?.value.join() : attribute.value }
            }
            if (attribute?.name) {
                return { name: key, value: Array.isArray(attribute.name) ? attribute?.name.join() : attribute.name }
            }
            if (attribute?.material) {
                return { name: key, value: attribute.material.value }
            }
            if (key.includes('main_offer_image_locator')) {
                return { name: key, value: attribute[0]?.media_location };
            }
        },
        "Ebay": (attribute, key) => {
            return { name: key, value: Array.isArray(attribute) ? attribute?.join() : attribute }
        },
        "Shopify": (attribute, key) => {
            if (attribute && key != "image" && key != 'images' && key != 'variants' && key != 'options') {
                return {
                    name: key, value: (() => {
                        if (Array.isArray(attribute)) {
                            return attribute.join()
                        } else if (typeof attribute === 'object') {
                            let values = "";
                            Object.keys(attribute).forEach((e) => {
                                values += `${e}: ${attribute[e]} `;
                            })
                            return values;
                        } else {
                            return attribute;
                        }
                    })()

                }
            }
        },
        "Walmart": (attribute, key) => {
            return {
                name: key, value: (() => {
                    if (Array.isArray(attribute)) {
                        return attribute.join()
                    } else if (typeof attribute === 'object') {
                        let values = "";
                        Object.keys(attribute).forEach((e) => {
                            values += `${e}: ${attribute[e]} `;
                        })
                        return values;
                    } else {
                        return attribute;
                    }
                })()
            }
        }
    }

    useEffect(() => {
        setImages([]);
        setAttributes(null);
        if (visible?.data?.attributes) {
            let data = visible?.data?.attributes?.length > 0 ? visible.data.attributes[0] : visible.data.attributes;
            let attbs = [];
            for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    const element = data[key];
                    const value = visible.data.marketplace.includes(sellerMarketplaces.AMAZON) ?
                        getAttributesByMarketplace[sellerMarketplaces.AMAZON](element, key) :
                        getAttributesByMarketplace[visible.data.marketplace](element, key);
                    if (value) {
                        attbs.push(value);
                    }
                }
            }
            let imgs = [...visible?.data?.mainImages, ...visible?.data?.productImages];
            setImages(imgs?.map(img => img.url));
            setAttributes(attbs);
        }
    }, [visible])

    const getProperties = () => {
        return (
            <>
                <Title level={2} >{visible?.data?.marketplace}</Title>
                <Divider />
                <Row style={{ overflowY: 'scroll', height: 600 }}>
                    <Col span={8}>
                        <Title level={4} type="secondary">Imágenes del producto</Title>
                        <Image.PreviewGroup>
                            {images?.length > 0 ? images?.map((img, index) => (
                                <Image width={images?.length > 6 ? 75 : 150} src={img} key={index} />
                            )) : <Image
                                width={150}
                                height={150}
                                src="error"
                                fallback="data:image/png;base64,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"
                            />}
                        </Image.PreviewGroup>
                    </Col>
                    <Col span={16}>
                        <Title level={4} type="secondary">Atributos</Title>
                        <Row>
                            {attributes?.map((property, index) => (
                                <Col span={12} key={index} style={{ marginBottom: 10 }}>
                                    <Title level={5} className="text-capitalize">{property.name?.replace(/_/g, " ")}</Title>
                                    <Text>{property.value}</Text>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row >
            </>
        )

    }


    return (
        <Modal
            title={visible?.title}
            cancelText={'Cerrar'}
            okButtonProps={{ style: { display: 'none' } }}
            centered
            visible={visible?.value}
            onOk={() => setVisible({ value: false, data: null })}
            onCancel={() => setVisible({ value: false, data: null })}
            width={1000}
        >
            {visible?.data?.marketplace && getProperties()}
        </Modal>
    );
}